
import React from 'react';
import customStyles from "../../../../../../assets/styles/customStyles";
import { Button, Box } from "@mui/material";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import { Row, Col, Space } from "antd";
import clsx from "clsx";
import { idNamingConversion } from '../../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";

export const RunQuery = (props) => {
    const { visible, handleClose, createProduct, changeHandler, productApi, form, customObject, productGroupDetails, myProductdetails, locationDetails } = props;


    const handleSubmit = (e) => {
        e.preventDefault();
        createProduct(form);
        handleClose();
    }


    const classes = customStyles();
    return <PrimaryDrawer
        anchor={'right'}
        open={visible}
        variant={'temporary'}
        handleClose={() => handleClose()}
        title={`Create Stock Transfer Lines`}
        width={'495px'}
        className={clsx(classes.closeBackGround, classes.width100P)}
        component={
            <Box
                className={clsx(classes.customForm, classes.removeUnderline)}
                component="form"
                autoComplete="off"
                onSubmit={(e) => handleSubmit(e)}>
                <div className={classes.customFormFlex}>
                    <Row type="flex" gutter={40}>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.customerLabelNone}>
                            <AutoCompleteComponent
                                name={["Product "]}
                                heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                { 'key': 'productId', 'name': 'Product ID' }, { 'key': 'universalProduct', 'name': 'UPI Id', 'relation': 'productId' }]}
                                details={myProductdetails}
                                id={idNamingConversion('Product', 'stockCount', 'DropDown')}
                                parentValue={customObject(myProductdetails, form?.productId)}
                                position={"bottom"}
                                searchType={(s) => productApi(s)}
                                onChange={(data) => changeHandler(data.id, 'productId')}
                            />
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.customerLabelNone}>
                            <AutoCompleteComponent
                                name={["Product Group "]}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={productGroupDetails}
                                parentValue={customObject(productGroupDetails, form?.groupId)}
                                position={"bottom"}
                                id={idNamingConversion('Product Group', 'stockCount', 'DropDown')}
                                customClasses={classes.margin30t}
                                onChange={(data) => changeHandler(data.id, 'groupId')}
                            />
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.customerLabelNone}>
                            <AutoCompleteComponent
                                name={["Location "]}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={locationDetails}
                                parentValue={customObject(locationDetails, form?.locationId)}
                                position={"bottom"}
                                id={idNamingConversion('Location', 'stockCount', 'DropDown')}
                                customClasses={classes.margin30t}
                                onChange={(data) => changeHandler(data.id, 'locationId')}
                            />
                        </Col>
                    </Row>
                </div>
                <div className={clsx(classes.btnParent)}>
                    <Space size={[10, 10]} direction="horizontal" align="center">
                        <Button
                            key="ok"
                            color="primary"
                            variant="contained"
                            type={'submit'}
                            className={clsx(classes.modalBtn)}>
                            OK
                        </Button>
                        <Button
                            key="cancel"
                            color="primary"
                            variant="contained"
                            onClick={() => handleClose()}
                            className={clsx(classes.AddMoreBtn)}
                        >Cancel</Button>
                    </Space>
                </div>
            </Box>
        }
    />
}